import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'language-settings.global-objects-panel.header',
		defaultMessage: 'Global Jira admin objects',
		description: 'Heading of global objects panel',
	},
	description: {
		id: 'language-settings.global-objects-panel.description',
		defaultMessage:
			'Jira Service Management uses objects from Jira Administration, which may be shared across projects. These following objects are edited and translated in Jira Administration.',
		description: 'Description of global objects panel',
	},
	prioritiesLabel: {
		id: 'language-settings.global-objects-panel.priorities-label',
		defaultMessage: 'Priorities',
		description: 'Priorities page link label',
	},
	resolutionsLabel: {
		id: 'language-settings.global-objects-panel.resolutions-label',
		defaultMessage: 'Resolutions',
		description: 'Resolutions page link label',
	},
	contactDescription: {
		id: 'language-settings.global-objects-panel.contact-description',
		defaultMessage: 'Contact your Jira admin to translate global Jira admin objects.',
		description: 'Contact description',
	},
});
